import { ButtonRow, Icon } from '@cb/apricot-react'
import { formatDateTime, DATETIME_FORMATS } from '@myap/ui-library'
import useUserSettingsQuery from '../../../hooks/useUserSettingsQuery'
import GoToScoreSendsButton from './GoToScoreSendsButton'
import { USER_PROMPT_MODAL_UPDATE } from './constants'

function ScoreSendContent({ isModal = false, adjustHeight, userPromptType, setShouldCloseModal }) {
  // Get user details
  const { systemDates } = useUserSettingsQuery()
  const { diSelectionEndDate } = systemDates?.deadlines ?? {}

  useEffect(() => {
    let isCurrent = true

    if (isCurrent && isModal && adjustHeight) {
      setTimeout(() => adjustHeight(), 350)
    }
    return () => {
      isCurrent = false
    }
  }, [isModal, adjustHeight])

  return (
    <>
      {isModal ? (
        <div className="cb-modal-content">
          {userPromptType === USER_PROMPT_MODAL_UPDATE ? (
            <p>
              <Icon
                name="exclamation"
                circular
                color="red1"
                style={{ display: 'inline-block', top: '8px' }}
              />{' '}
              The recipient you previously selected is no longer valid. Please select a new
              recipient.
            </p>
          ) : null}
          <p>
            Each year you take AP Exams, you can have your AP score report sent for free to one
            recipient (a college, university, or scholarship organization). Your official score
            report includes the scores from all AP Exams taken this year and any AP Exams you&#39;ve
            previously taken, along with certain demographic information about you and other
            information you provide during testing. Schools use your official score report to
            determine credit or placement, if applicable. Colleges, universities, and scholarship
            programs that you send your score to may also use your information and official score
            report to contact you with information about admissions, educational, financial aid, and
            scholarship opportunities.
          </p>
          <p>
            To send your score report, go to the <strong>Free Score Sends</strong> page.
          </p>
          <p className="cb-margin-bottom-24">
            If you haven&#39;t finalized your decision on where you&#39;re attending college, select
            the school you think you&#39;re most likely to attend. You can change your recipient any
            time by{' '}
            <strong>{formatDateTime(diSelectionEndDate, DATETIME_FORMATS.longMonthDayYear)}</strong>
            . Your score report will be sent in July.
          </p>
        </div>
      ) : (
        <>
          {userPromptType === USER_PROMPT_MODAL_UPDATE ? (
            <p>
              <Icon
                name="exclamation"
                circular
                color="red1"
                style={{ display: 'inline-block', top: '8px' }}
              />{' '}
              The recipient you previously selected is no longer valid. Please select a new
              recipient.
            </p>
          ) : null}
          <p>
            Each year you take AP Exams, you can have your AP score report sent for free to one
            recipient (a college, university, or scholarship organization). Your score report
            includes the scores from all AP Exams taken this year and any AP Exams you&#39;ve taken
            in previous years, along with certain demographic information about you and other
            information you provide during testing. To send your score, go to the{' '}
            <strong>Free Score Sends</strong> page. You may designate your recipient any time before{' '}
            <strong>{formatDateTime(diSelectionEndDate, DATETIME_FORMATS.longMonthDayYear)}</strong>
            .
          </p>
        </>
      )}
      {isModal ? (
        <div className="cb-modal-footer">
          <ButtonRow>
            {userPromptType === USER_PROMPT_MODAL_UPDATE ? (
              <button
                type="button"
                className="cb-btn cb-btn-naked"
                onClick={() => setShouldCloseModal(true)}
              >
                Continue to My AP
              </button>
            ) : null}
            <GoToScoreSendsButton />
          </ButtonRow>
        </div>
      ) : (
        <div className="display-flex cb-margin-top-24 justify-content-center">
          <GoToScoreSendsButton />
        </div>
      )}
    </>
  )
}

export default ScoreSendContent
